var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5C7.775 5 6.39167 6.10833 5.83334 8.33333C6.66667 7.225 7.64167 6.80833 8.75 7.08333C9.38334 7.24167 9.84167 7.7 10.3417 8.20833C11.1583 9.04167 12.0833 10 14.1667 10C16.3917 10 17.775 8.89167 18.3333 6.66667C17.5 7.775 16.525 8.19167 15.4167 7.91667C14.7833 7.75833 14.3333 7.3 13.825 6.79167C13.0083 5.95833 12.0833 5 10 5ZM5.83334 10C3.60834 10 2.22501 11.1083 1.66667 13.3333C2.50001 12.225 3.47501 11.8083 4.58334 12.0833C5.21667 12.2417 5.66667 12.7 6.175 13.2083C6.99167 14.0417 7.91667 15 10 15C12.225 15 13.6083 13.8917 14.1667 11.6667C13.3333 12.775 12.3583 13.1917 11.25 12.9167C10.6167 12.7583 10.1667 12.3 9.65834 11.7917C8.84167 10.9583 7.91667 10 5.83334 10Z",
    fill: "#00FF7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.475a0d79358e6ed1ad6f48d7f0024e11.svg";
export { ForwardRef as ReactComponent };